import { createContext, useContext } from 'react'

import { SCHEDULES_PATH } from '../constants'

export const SCHEDULE_QUERY_PARAM = 'schedule'

const parsePathScheduleId = (params) => {
  const raw = params?.id
  if (raw == null || raw === '') return undefined
  const n = Number(raw)
  return Number.isFinite(n) ? n : NaN
}

const parseQueryScheduleId = (search) => {
  const raw = new URLSearchParams(search).get(SCHEDULE_QUERY_PARAM)
  if (raw == null || raw === '') return undefined
  const n = Number(raw)
  return Number.isFinite(n) ? n : NaN
}

const defaultSchedulesRoutes = {
  parseRouteScheduleId: (params, _search) => parsePathScheduleId(params),
  hrefForSchedule: (scheduleId, defaultScheduleId) => (
    scheduleId === defaultScheduleId ? SCHEDULES_PATH : `${SCHEDULES_PATH}/${scheduleId}`
  ),
  invalidRedirectHref: () => SCHEDULES_PATH,
}

/**
 * Routes for the Scheduling → Availability tab (new shell). Schedule id lives in the query
 * string so it does not collide with homePaths' `:id` scope segment (e.g. /user/me).
 */
export const createSchedulingEmbedSchedulesRoutes = (listPath) => {
  const basePath = listPath.split('?')[0]

  return {
    parseRouteScheduleId: (_params, search) => parseQueryScheduleId(search),
    hrefForSchedule: (scheduleId, defaultScheduleId) => (
      scheduleId === defaultScheduleId
        ? basePath
        : `${basePath}?${SCHEDULE_QUERY_PARAM}=${encodeURIComponent(String(scheduleId))}`
    ),
    invalidRedirectHref: () => basePath,
  }
}

const SchedulesRoutesContext = createContext(defaultSchedulesRoutes)

export const SchedulesRoutesProvider = SchedulesRoutesContext.Provider

export const useSchedulesRoutes = () => useContext(SchedulesRoutesContext)

const mergePathWithSearch = (pathname, searchString) => {
  const q = searchString?.replace(/^\?/, '') ?? ''
  return q ? `${pathname}?${q}` : pathname
}

export const pushHrefPreservingSearchExcept = (history, keysToRemove) => {
  const sp = new URLSearchParams(history.location.search)
  keysToRemove.forEach((k) => sp.delete(k))
  const next = sp.toString()
  history.push(mergePathWithSearch(history.location.pathname, next))
}

export const pushHrefMergingSearch = (history, patchEntries) => {
  const sp = new URLSearchParams(history.location.search)
  Object.entries(patchEntries).forEach(([k, v]) => {
    if (v == null) sp.delete(k)
    else sp.set(k, String(v))
  })
  const next = sp.toString()
  history.push(mergePathWithSearch(history.location.pathname, next))
}
